var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHoldicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 24,
    height: 24,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(-65.25 -515.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "keypadicon",
    transform: "translate(119.25 512.25)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 27.25,
    cy: 27.25,
    r: 27.25,
    transform: "translate(-53.25 3.75)",
    fill: "#fff",
    stroke: "#f3f7fb",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "hold",
    transform: "translate(81 531)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M16,18a1.5,1.5,0,0,1-1.5-1.5v-9a1.5,1.5,0,1,1,3,0v9A1.5,1.5,0,0,1,16,18Z",
    fill: "none",
    stroke: "#080428",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M8,18a1.5,1.5,0,0,1-1.5-1.5v-9a1.5,1.5,0,1,1,3,0v9A1.5,1.5,0,0,1,8,18Z",
    fill: "none",
    stroke: "#080428",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoldicon);
export default __webpack_public_path__ + "static/media/holdicon.914860e4758175b4795f46d4fdbecd5e.svg";
export { ForwardRef as ReactComponent };